import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h2>This is not the web page you are looking for</h2>
        </div>
    );
};

export default NotFound;
